import { render, staticRenderFns } from "./TextBtn.vue?vue&type=template&id=4a33b650"
import script from "./TextBtn.vue?vue&type=script&lang=ts"
export * from "./TextBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports